export const ROUTE_LANDING_PAGE = '/';
export const ROUTE_INTRO = '/intro-page';
export const ROUTE_ONBOARDING = '/onboarding';
export const ROUTE_REGISTER_KIT = '/registerkit';
export const ROUTE_ASSESSMENT = '/assessment';
export const EMAIL_VERIFICATION = '/account/verified';
